import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import React, { useState, useEffect, useRef } from 'react'
import { Button, Form, Modal, ProgressBar, Row } from 'react-bootstrap';
import default_image_url from '../../../../../redux/api/API';
import MainLoading from '../../../../../utils/MainLoading';
import { fetchNewAd } from '../../../../../redux/action/ads/ad';
import { fetchDeleteAd } from '../../../../../redux/action/ads/deleteAd';
import SimpleReactValidator from 'simple-react-validator'
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const SaloonOne = (props) => {
    const [path, setPath] = useState('')
    const [forceUpdate, setForceUpdate] = useState(0)
    const [photo, setPhoto] = useState('')
    const [uploadPercentage, setUploadPercentage] = useState(0)
    const [selectedImage, setSelectedImage] = useState();
    const [imageId, setImageId] = useState();
    const [progerssbar, setProgressbar] = useState(0)
    const [deleteAd, setDeleteAd] = useState(false)
    const dispatch = useDispatch()
    const all_ads = useSelector(state => state.all_ads)
    let i = 0;
    const {t} = useTranslation();

    const isInitialMount = useRef(true);
    const handleClose = () => { 
        setDeleteAd(false) 
    }

    useEffect(() => {
        if (isInitialMount.current) {
           isInitialMount.current = false;
        } else {
            setUploadPercentage(100)
            setTimeout(() => {
                setUploadPercentage(0)
            }, 1000);
            setPath('')
            setPhoto()
            setSelectedImage()
            setProgressbar()
            props.update()
        }
    }, [forceUpdate]);

    const handleSelectImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedImage(e.target.files[0]);
        }
        setPhoto(e.target.files[0])
    }

    const removeSelectedImage = () => {
        setSelectedImage();
        setPhoto()
    };

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    const handleUploadImage = (e) => {
        e.preventDefault()
        if (validator.current.allValid()) {
            setProgressbar(true)

            const formData = new FormData();
            formData.append('image',photo)
            formData.append('url',path)
            formData.append('location', 'saloons')
            formData.append('position', 'top')

            const config = {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: (progressEvent) => {
                    const {loaded, total} = progressEvent;
                    let percent = Math.floor( (loaded * 100) / total )
                    if( percent < 100 ){
                        setUploadPercentage(percent)
                    }
                }
            }

            dispatch(fetchNewAd(formData, config))
            isInitialMount.current = false;
            setForceUpdate(i+=2)
        } else {
            toast.dismiss()
            toast.error(t("toast Please enter the ad link") , {position: 'bottom-right'})
            validator.current.showMessages()
        }
    }

    const deleteThisAdModal = (id) => {
        setImageId(id)
        setDeleteAd(true) 
    }

    const deleteThisAd = () => {
        dispatch(fetchDeleteAd(imageId))
        setDeleteAd(false) 
        isInitialMount.current = false;
        setForceUpdate(i+=1)
    }

    return (
        <div className='mt-1'>
            <h6> {t("saloons page first sidebar ad")} : </h6> 
            <span>{t("Recommended_size_260_260")}</span>
            <Row className='single_gallery_images pb-5'>
                {all_ads.loading ?
                    <MainLoading />
                :
                    all_ads.all_ads.length && all_ads.all_ads.find(item => item.location === 'saloons' & item.position === 'top') ?
                        all_ads.all_ads.filter(item => item.location === 'saloons' & item.position === 'top').map(pic =>
                            <div className='ad_pic' key={pic.id}>
                                <img src={default_image_url+pic.path} />
                                <span>{pic.url}</span>
                                <button className='btn btn-danger btn-sm px-5' onClick={id => deleteThisAdModal(pic.id)}> {t("delete")} </button>
                            </div>
                        )
                    :
                    progerssbar ? 
                        <div className='col-lg-5 selectImage'>
                            {selectedImage && (
                                <div className='selectedImage'>
                                    <img
                                    src={URL.createObjectURL(selectedImage)}
                                    alt="Thumb"
                                    />
                                </div>
                            )}
                            {uploadPercentage > 0 && <ProgressBar className='mt-3' style={{width: '90%',border: '1px solid #000',margin: '.2rem'}} now={uploadPercentage} active="true" label={`${uploadPercentage}%`} />}
                        </div>
                    :
                        <div className='col-lg-5 selectImage'>
                            {selectedImage && (
                                <div className='selectedImage'>
                                    <img
                                    src={URL.createObjectURL(selectedImage)}
                                    alt="Thumb"
                                    />
                                    <button onClick={removeSelectedImage} className='remove_selected_image'>
                                    <i className='fa fa-times'></i>
                                    </button>
                                </div>
                            )}
                                {photo ? 
                                    <>
                                        <div className='gallery_container'>
                                            <Form className='submitForm' onSubmit={handleUploadImage}>
                                                <button className='btn btn-success btn-sm px-4'>{t("send")}</button>
                                            </Form>
                                            <div className='imageName'>
                                                <input type="text" placeholder={t("url")} name={path} onChange={e => setPath(e.target.value)} />
                                                <span className='validator_error'>{validator.current.message('path', path, 'required')}</span>

                                            </div>
                                        </div>
                                    </>
                                :
                                    <Form className='chooseForm' onSubmit={handleUploadImage}>
                                        <input type="file" className='create_new_image_input' name="photo" value={photo} onChange={handleSelectImage}/>
                                        <i className='fa fa-plus'></i>
                                        <span>{t("add new picture")}</span>
                                    </Form>
                                }
                        </div>
                }
                
                {deleteAd ? 
                    <Modal show={deleteAd} onHide={handleClose}>
                        <Modal.Header>
                            <Modal.Title>{t("delete this item")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                {t("Cancel")}
                            </Button>
                            <Button variant="primary" onClick={deleteThisAd}>
                                {t("confirm")}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                : ''}
            </Row>
        </div>

    )
}

export default SaloonOne

